import React from "react";
import { style } from "typestyle";
import L from "leaflet";

type LeafletStyle = any;
export type Legend = {
  title: string;
  layerStyle?: LeafletStyle;
  iconUrl?: string;
  order?: number;
};
type LegendControlProps = {
  legends: Legend[];
};
const LegendControl = ({ legends }: LegendControlProps) => (
  <div
    className={style({
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "12px",
      $nest: {
        "&>*": {
          paddingBottom: "8px",
          $nest: {
            "&:last-child": {
              paddingBottom: "0px",
            },
          },
        },
      },
    })}
  >
    {legends
      .sort((a: Legend, b: Legend) => {
        if (!a.order || !b.order) {
          return 0;
        }
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      })
      .map((props, i) => (
        <LegendItem {...props} key={i} />
      ))}
  </div>
);

type LegendItemProps = Legend;
const LegendItem = ({ title, layerStyle, iconUrl }: LegendItemProps) => (
  <div
    className={style({
      display: "flex",
    })}
  >
    <div className={style({ paddingRight: "8px" })}>
      {(() => {
        if (layerStyle) {
          return <LegendPathSample layerStyle={layerStyle} />;
        }
        if (iconUrl) {
          return <img src={iconUrl} />;
        }
      })()}
    </div>
    <div>{title}</div>
  </div>
);

type LegendPathSampleProps = {
  layerStyle: LeafletStyle;
};
const LegendPathSample = ({ layerStyle }: LegendPathSampleProps) => {
  const defaultLeafletStyle = L.Path.prototype.options;
  const composedStyle = { ...defaultLeafletStyle, ...layerStyle };
  return (
    <svg width="40" height="10" viewBox="0 0 40 10">
      <g>
        <path
          d="M 5 5 L 35 5"
          stroke={composedStyle.color}
          strokeOpacity={composedStyle.opacity}
          strokeWidth={composedStyle.weight}
          strokeLinecap={composedStyle.lineCap}
          strokeLinejoin={composedStyle.lineJoin}
          strokeDasharray={composedStyle.dashArray}
        ></path>
      </g>
    </svg>
  );
};

export default LegendControl;
